import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    // Fill the dialog's min-height (MuiDialog paperWidthLg forces 290px) so the footer can
    // bottom-anchor instead of floating mid-modal on short content (#31068).
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  title: {
    textAlign: 'center'
  },
  footer: {
    // Push the close button down to the bottom padding — adds breathing room above it and
    // removes the dead space below. On tall content this is a no-op (no slack to absorb).
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    width: 136
  }
}));

export default useStyles;
